<template>
  <div>
    <div class="select_area block">
      <el-row>
        <el-col :span="8">
          <span class="item_title">请选择地区：</span>
          <div style="width: 100%">
            <up-cascader ref="instrument" v-model="instrSelectedArea" :filterable="true" :remote="false" :props="{multiple: true}"  :clearable="true"
                         :options="areaOptions"  @change="handleChangeArea" :maxCount="2"
                         :myClass=" type== 1 ? 'instrument-area-tags' : 'instrument-area-tags2'"
                         :class=" type== 1 ? 'instrument-area-tags' : 'instrument-area-tags2'"
                       placeholder="请选择地区" />
          </div>
        </el-col>
        <el-col :span="8">
          <span class="item_title">请选择医院：</span>
          <div>
            <el-select
                multiple
                v-model="hospital_selected"
                placeholder="请输入医院名称"
                size="small"
                filterable
                clearable
                collapse-tags
                :remote="true"
                :loading="searchLoading"
                :remote-method="handleSearchHos"
                @change="handle_change_hospital"
            >
              <el-option
                  v-for="item in hospitalOptions"
                  :key="item.hospital"
                  :label="item.hospital_full_name"
                  :value="{label:item.hospital_full_name,value:item.hospital}"
              ></el-option>
            </el-select>
            <div class="block" v-if="instrSelectedArea.length > 0 " style="margin-top: 10px">
              <el-checkbox v-model="checkedAllhos" @change="handle_select_all_hos()">全部医院</el-checkbox>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <span class="item_title">请选择机号：</span>
          <div>
            <el-select
                multiple
                v-model="instrument_selected"
                placeholder="请选择机号"
                size="small"
                filterable
                remote
                clearable
                collapse-tags
                :loading="searchLoading"
                :remote-method="handleSearch"
                @change="handle_change_instru"
                @clear="handle_del_select_all_instr"
            >
              <el-option
                  v-for="item in instruOptions"
                  :key="item.instrument_id"
                  :disabled="item.disabled"
                  :label="item.combined_field"
                  :value="{label:item.combined_field,value:item.instrument_id,
                  province_id: item.province.value,provinceName: item.province.label,city_id:item.city.value,
                  city_name: item.city.label,customerId:item.customer,hospitalId: item.hospital,hospitalName:  item.hospital_full_name}"
              ></el-option>
            </el-select>
            <div class="block" v-if="hospital_selected.length > 0 " style="margin-top: 10px">
              <el-checkbox v-model="checkedAllInstr" @change="handle_select_all_instr()">全部机号</el-checkbox>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="result_area block" v-loading="areaLoading">
      <div>
        <div class="left" style="display: inline-block;width: 50%;">

          <span class="item_title">已选择机号：</span>
          <el-checkbox v-model="checkedAllSelected" @change="handle_del_select_all()">全选</el-checkbox>
          <el-button @click="handle_delete()" size="mini" style="margin-left: 14px;background: #BD3124;color: #fff;border:none;">全部删除</el-button>
        </div>
        <div style="display: inline-block;width: 50%;text-align: right">
          <el-input v-model="key_word" size="mini" placeholder="请输入关键字" style="display: inline-block;width: 170px"></el-input>
          <el-button size="mini" @click="handle_filter" style="margin-left: 14px;background: #0052D9;color: #fff;vertical-align: top">查找</el-button>
        </div>
      </div>
      <div class="tag_list">
        <div  v-for="item in instrDisplayList" style="display: block" :key="item.value">
<!--          <span style="margin-right: 14px;font-weight: bold;">{{item.provinceName}}:</span>-->
          <div  v-for="(ite,index) in item.hos_list" :key="index" style="display: inline-block; padding-right: 14px; box-sizing: border-box;width: 100%;font-weight: bold;">
            <span style="width: 90px;display: inline-block;line-height: 46px;">{{index > 0 ? '' : item.area_name}}</span>
            <div style="display: inline-block; width:calc(100% - 90px);vertical-align: top;box-sizing: border-box">
            <span style="display:inline-block; padding-right: 14px;font-weight: normal;box-sizing: border-box ">{{ite.hospital_name}}:</span>
             <el-tag
                 v-for="tag in ite.instr_list"
                 class="item_tag"
                 :class="{'active-class': tag.isActive,}"
                 effect="dark"
                 style="font-weight: normal"
                 @close="handleClose(tag)"
                 closable>
            {{tag.combined_field}}
          </el-tag>
          </div>
          </div>


        </div>
      </div>
    </div>
    <el-dialog
        title=""
        :visible.sync="instr_dialogVisible"
        :modal="false"
        :modal-append-to-body="false"
        width="30%"
        :before-close="handleCloseDelete">
      <span>删除后不可恢复，确认要删除吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="instr_dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmDeleteAll" style="background: #0052D9">确定删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import {hospitals_list} from "@/api/search";
import upCascader from "@/components/upCascader.vue";
import api from "@/api/manage";
import {deepCopy} from "ali-oss/lib/common/utils/deepCopy";

export default {
  components: {upCascader},
  props:{
    instrumentDataInfo:{
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      searchLoading:false,
      checkedAllInstr: '',
      checkedAllhos: false,
      key_word: '',
      instrSelectedArea: [],
      hospital_selected: [],
      instruDisplayList: [],
      instruSelectSubmitList: [],
      instrument_selected: [],
      props: { multiple: true },
      hospitalOptions:[],
      instruOptions:[],
      areaOptions: [],
      checkedAllSelected:false,
      instr_dialogVisible:false,
      instrSelectedProvinceVal:[],
      instrSelectedCityVal:[],
      instrSelectOriginList: [], //选中的原始数据，可能不是展示数据，但是提交的原始数据
      instrSelectOriginListTemp: [], //选中的要展示的原始数据，主要为了区分筛选后的数据
      instrDisplayList: [], // 处理过最终展示的选中数据（可能是筛选过的，但不是提交的数据）
      instrSelectSubmitList: {}, //处理过最终的提交数据
      areaLoading: false, //搜索时加载中
      instrAllLength: 0, // 在机号选择栏下方，选中全部仪器时的数量

    };
  },
  mounted() {
    let originData = JSON.parse(localStorage.getItem('province'));
    setTimeout(()=>{
      originData.forEach((item) => {
        if(item.city_list && item.city_list.length >0 ){
          item.children = []
          item.children = item.children.concat(item.city_list)
        }
      })
      this.areaOptions = originData
    },300)
  },
  watch: {
    instrumentDataInfo(val){
      // console.log('instrumentDataInfo-jianting000')
      if(val){
        this.initData()
      }
    }
  },
  methods: {
    initData(){ //初始化数据,为了保存后回显数据
      console.log('instrumentDataInfo-jianting-------',this.instrumentDataInfo.length)
      if(this.instrumentDataInfo.length >0){
        let instrumentDataInfoTemp = this.instrumentDataInfo
        instrumentDataInfoTemp.forEach((item) => {
          item.label = item.combined_field
          item.value = item.instrument_id
          item.provinceName = item.province_name
          item.province_id = item.province_id
          item.cityName = item.city_name
          item.city = item.city_id
          item.customerId = item.customer_id
          item.hospitalId = item.hospital_id
          item.hospitalName = item.hospital_name
        })
        // console.log('instrumentDataInfoTemp-init9090987654321 ==',instrumentDataInfoTemp)
        this.instrSelectOriginList = instrumentDataInfoTemp
        this.instrSelectOriginListTemp = instrumentDataInfoTemp
        this.rebuildDisplayData()
        this.rebuildSubmitData()
      }
    },
    rebuildDisplayData(){ // 重组展示数据
      // 这是新增的
      const result = [];
      const cityMap = {};
      console.log('instrSelectOriginListTemp===初始化', this.instrSelectOriginListTemp);
      this.instrSelectOriginListTemp.forEach(item => {
        const { city_id, city_name, province_id, province_name,provinceName, cityName,customer_id, hospital_id, hospital_name, instrument_id, combined_field } = item;
        const area_name = `${province_name ? province_name : provinceName ? provinceName : '其它' }/${city_name ? city_name : cityName ? cityName : '其它'}`;
        if (!cityMap[city_id]) {
          cityMap[city_id] = {
            city_id,
            city_name,
            province_id,
            province_name,
            area_name,
            hos_list: []
          };
          result.push(cityMap[city_id]);
        }
        const city = cityMap[city_id];
        let hospital = city.hos_list.find(h => h.hospital_id === hospital_id);
        if (!hospital) {
          hospital = {
            customer_id,
            hospital_name,
            hospital_id,
            instr_list: []
          };
          city.hos_list.push(hospital);
        }
        hospital.instr_list.push({
          instrument_id,
          combined_field
        });
      });
// 由于示例数据中只包含了东城的数据，西城和洛阳的数据需要用户自行添加或生成
// 这里只是为了展示结果结构，所以直接打印出东城的数据
//       console.log(result);
      // 新增的结束
      this.instrDisplayList = result;
      console.log('instrDisplayList===666', this.instrDisplayList);
    },
    rebuildSubmitData(){ // 重组提交数据
      // const areaData = [];
      const instrumentIds = [];
      const provinceMap = new Map();
      // console.log('instrSelectOriginList-yuanshi1233333==',this.instrSelectOriginList)
      const transformedArray = this.instrSelectOriginList.reduce((acc, item) => {
        instrumentIds.push(item.value);
        const provinceId = item.province_id
        const cityId = item.city_id

        if (!acc[provinceId]) {
          acc[provinceId] = {
            province_id: provinceId,
            city: []
          };
        }
        if(cityId){
          acc[provinceId].city.push(cityId);
        }
        return acc;
      }, {});

      const areaData = Object.values(transformedArray);
      areaData.forEach( item=>{
        item.city = [...new Set(item.city)]
      })
      let customer_ids = this.instrSelectOriginList.map(item =>{return item.customerId } );
      let hospital_ids = this.instrSelectOriginList.map(item =>{ return item.hospitalId } );
      customer_ids = [...new Set(customer_ids)]
      hospital_ids = [...new Set(hospital_ids)]
      this.instrument_permission=  {
        area_data: areaData,
        customer_ids,
        hospital_ids,
        instrument_id: [...new Set(instrumentIds)] // 使用Set去重，然后转换回数组
      }
      // 输出结果以验证
      // console.log('提交的instrument_permission:', this.instrument_permission);
      this.instrSelectSubmitList = this.instrument_permission
    },
    handleChangeArea(value, selectedData) { // 下拉选择区域
      if(value.length > 0){
        this.instrSelectedProvinceVal = this.instrSelectedArea.map(subArray => subArray[0]);
        this.instrSelectedCityVal = this.instrSelectedArea.map(subArray => subArray[1]);
      }else{ // 清空地区
        this.checkedAllhos = false
        this.hospital_selected = []
        this.instrument_selected = []
        this.checkedAllInstr = false
      }
    },
    handle_select_all_hos(){
      if(this.checkedAllhos){
        this.hosRemoteMethod('','all')
      }
    },
    // 防抖处理后的搜索方法-医院
    handleSearchHos: debounce(function(event) {
      const keyword = event;
      if( this.instrSelectedProvinceVal.length >0 ||this.instrSelectedCityVal.length >0 || keyword){
        this.hosRemoteMethod(keyword); // 实际搜索逻辑
      }
    }, 1500),
    hosRemoteMethod(e,type) {
      this.instrSelectedProvinceVal = [...new Set(this.instrSelectedProvinceVal)]
      let params = {
        type:'hospital',
        province_id: this.instrSelectedProvinceVal.toString(),
        city_id: this.instrSelectedCityVal.toString(),
        hospital_name: e
      }
      if( this.instrSelectedProvinceVal.length >0 ||this.instrSelectedCityVal.length >0 || e){
        this.searchLoading = true
      api.system_search_data(params).then(res=>{
        this.hospitalOptions = res.data
        this.searchLoading = false
        if(type == 'all'){
          let resData = res.data
          resData.forEach((item) => {
            item.label = item.hospital_full_name
            item.value = item.hospital
            item.provinceName = item.province.label
            item.province_id = item.province.value
            item.cityName = item.city.label
            item.city = item.city.value
            item.customerId = item.customer
          })
          // console.log('resData-hos==',resData)

          this.hospital_selected  = this.hospital_selected.concat(resData)
          let arrayTemp = this.hospital_selected
          this.hospital_selected = Array.from(new Map(arrayTemp.map(item => [item.value, item]))).map(item => item[1])

        }
      }).finally(()=>{
        this.searchLoading = false
      } )
        }
    },

    // 防抖处理后的搜索方法-仪器
    handleSearch: debounce(function(event) {
      const keyword = event;
      this.searchLoading = true
      console.log('handleSearch-keyword==', keyword)
      if(this.instrSelectedCityVal.length >0 || this.hospital_selected.length >0 || keyword){
        this.instruRemoteMethod(keyword); // 实际搜索逻辑
      }
    }, 1000),
    handle_select_all_instr(){
      if(this.checkedAllInstr){
        this.instruRemoteMethod('','all')
      }
    },
    instruRemoteMethod(e,type) {
      this.searchLoading = true
      let hostpital_id = this.hospital_selected.map(item => item.value)
      this.instrSelectedProvinceVal = [...new Set(this.instrSelectedProvinceVal)]
      let params = {
        type:'instrument',
        province_id: this.instrSelectedProvinceVal.toString(),
        city_id: this.instrSelectedCityVal.toString(),
        hospital_id: hostpital_id.toString(),
        instrument_id: e
      }
      if(this.instrSelectedCityVal.length >0 || this.hospital_selected.length >0 || e){
      api.system_search_data(params).then(res=>{ //选中全部医院
        this.instruOptions = res.data
        this.instruOptions.forEach(i => {
          i.city_id = i.city.value;
          i.city_name = i.city.label;
        })
        const existIds = new Set(
            this.instrSelectOriginList.map(item => item.value)
        );
        this.instruOptions.forEach(i => {
          i.disabled = existIds.has(i.instrument_id);
        });
        if(type == 'all'){
          let resData = res.data
          this.instrAllLength = resData.length
          let resDataTemp = deepCopy(resData)
          resDataTemp.forEach((item) => {
            item.label = item.combined_field
            item.value = item.instrument_id
            item.provinceName = item.province.label
            item.province_id = item.province.value
            item.cityName = item.city.label
            item.city_id = item.city.value
            item.city_name = item.city.label
            item.customerId = item.customer
            item.hospitalId = item.hospital
            item.hospitalName = item.hospital_full_name ? item.hospital_full_name : item.hospitalName
            item.hospital_name = item.hospital_full_name ? item.hospital_full_name : item.hospitalName
            item.hospital_id = item.hospital ? item.hospital :item.hospitalId
          })
          console.log('resData-instr==',resData)
          this.instrument_selected  = this.instrument_selected.concat(resDataTemp)
          this.instrSelectOriginList =  this.instrSelectOriginList.concat(resDataTemp)
          this.instrSelectOriginListTemp = this.instrSelectOriginListTemp.concat(resDataTemp)
          this.instrSelectOriginList = Array.from(new Map(this.instrSelectOriginList.map(item => [item.value, item]))).map(item => item[1]) ;
          this.instrSelectOriginListTemp = Array.from(new Map(this.instrSelectOriginListTemp.map(item => [item.value, item]))).map(item => item[1]) ;
          this.instrument_selected = Array.from(new Map(this.instrument_selected.map(item => [item.value, item]))).map(item => item[1]) ;

          this.instruOptions.forEach(i => {
            i.disabled = true
          })
          console.log('instrument_selected---------------------==',this.instrument_selected)
          console.log('instrSelectOriginListTemp----------------==',this.instrSelectOriginListTemp)
          this.rebuildDisplayData()
          this.rebuildSubmitData()
        }
      }).finally(() => {
        this.searchLoading = false
      })
      }
    },
    handle_change_hospital(){
      if(this.hospital_selected.length == 0){ //清空医院
        this.checkedAllhos = false
        this.hospital_selected = []
        this.instrument_selected = []
        this.checkedAllInstr = false
      }

      this.instruRemoteMethod()
    },
    handle_change_instru(e){ // 选中某个仪器

      console.log('选中某个仪器===',e);
      if(e.length < this.instrSelectOriginList.length){
        this.checkedAllInstr = false
      }
      e.forEach(item => {
        item.city_id = item.city_id
        item.city_name = item.city_name
        item.province_id = item.province_id
        item.province_name = item.provinceName
        item.customer_id = item.customerId
        item.hospital_id = item.hospitalId
        item.hospital_name = item.hospitalName
        item.instrument_id = item.value
        item.combined_field = item.label
      })
      const selectedIds = e.map(item => item.instrument_id)
      this.instruOptions.forEach(i => {
        i.disabled = selectedIds.includes(i.instrument_id);
      })
      this.instrSelectOriginList = this.instrSelectOriginList.concat(e)
      this.instrSelectOriginListTemp = this.instrSelectOriginListTemp.concat(e)
      this.instrSelectOriginList = Array.from(new Map(this.instrSelectOriginList.map(item => [item.value, item]))).map(item => item[1]) ;
      this.instrSelectOriginListTemp = Array.from(new Map(this.instrSelectOriginListTemp.map(item => [item.value, item]))).map(item => item[1]) ;
      // this.instrument_selected = Array.from(new Map(this.instrument_selected.map(item => [item.value, item]))).map(item => item[1]) ;
      console.log('instrSelectOriginListTemp==',this.instrSelectOriginListTemp)
      this.rebuildDisplayData()
      this.rebuildSubmitData()
    },
    handle_del_select_all_instr(){
      this.checkedAllInstr =false
    },
    handleClose(tag) { // 删除某个选中的仪器
      console.log('tag===',tag)
      console.log('instrDisplayList===',this.instrDisplayList)
      this.instrSelectOriginListTemp = this.instrSelectOriginListTemp.filter(item => item.value !== tag.instrument_id)
      this.instrSelectOriginList = this.instrSelectOriginList.filter(item => item.value !== tag.instrument_id)
      this.instrDisplayList.forEach(item =>{  //删除展示的仪器
        item.hos_list.forEach((ite, index)=>{

          ite.instr_list.forEach((it ,index)=> {
            if(it.instrument_id == tag.instrument_id){
              ite.instr_list.splice(index, 1)
            }
          })
          if( ite.instr_list.length == 0){
            item.hos_list.splice(index, 1)
            // this.$message.info(`该医院已无仪器，请在【按医院分配中】删除【${ite.hospital_name}】医院`)
          }
        })
      })
      // 因为使用数据重组的方式，同一个地区包含不同的医院时候，删除某个仪器顺序会乱
      // this.rebuildDisplayData()
      this.rebuildSubmitData()
      this.instrument_selected = this.instrument_selected.filter(item => item.value !== tag.instrument_id)
      if(this.instrument_selected.length < this.instrAllLength){
        this.checkedAllInstr = false
      }
      // console.log('this.instrument_selected==',this.instrument_selected)
      this.instruOptions.forEach(i => {
        if(tag.instrument_id == i.instrument_id){
          i.disabled =false
        }
      })
    },
    handle_del_select_all(e){ //选择选中的所有的仪器
      // console.log('checkedAllSelected===',this.checkedAllSelected)
      if(this.checkedAllSelected){
        this.instrDisplayList.forEach(item =>{
          item.hos_list.forEach(ite=>{
           ite.instr_list.forEach(i=>{
             i.isActive = true
           })
          })
        })
      }else{
        this.instrDisplayList.forEach(item =>{
          item.hos_list.forEach(ite=>{
            ite.instr_list.forEach(i=>{
              i.isActive = false
            })
          })
        })
      }
      // console.log('this.instrDisplayList',this.instrDisplayList)
    },
    handle_delete(){
      this.instr_dialogVisible = true
    },
    confirmDeleteAll(){
      this.handle_delete_all()
      this.instr_dialogVisible = false
    },
    handle_delete_all(){ // 删除展示区域选中的所有的经销商
      if(this.key_word){
        const array1 = this.instrSelectOriginList
        const array2 = this.instrSelectOriginListTemp
        this.instrSelectOriginList = array1.filter(item1 =>
            !array2.some(item2 => item2.value == item1.value)
        );
      }else{
        this.instrSelectOriginList = []
      }
      this.instrSelectOriginListTemp = []
      this.instrument_selected = this.instrSelectOriginList
      this.checkedAllSelected = false
      this.rebuildDisplayData()
      this.rebuildSubmitData()
    },
    handle_filter(){ // 筛选
      // const array = this.selectSubmitList
      // this.instruDisplayList = array.filter(item => item.label.includes(this.key_word));
      // console.log('this.instruDisplayList===',this.instruDisplayList)
      this.instrSelectOriginListTemp =  this.instrSelectOriginList.filter(item => item.label.includes(this.key_word))
      this.rebuildDisplayData()
    },
    handleCloseDelete(){
      this.instr_dialogVisible = false
    }
  }
};
</script>

<style scoped lang="scss">
.block{
  display: block;
  .item_title{
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}
.result_area{
  margin-top: 20px;
}
.item_tag{
  margin:10px 14px 4px 0;
  background: #EFEFEF 50%;
  color: #4F4F4F;
  border:none;
  position: relative;

}
::v-deep .result_area .el-tag__close.el-icon-close{
  position: absolute;
  top: -8px;
  right: -8px;
  background: #BD3124;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  top: -2px;
}
::v-deep .choose_distribute .el-input__inner,::v-deep .result_area .el-input__inner{
  width: 100%!important;
}
::v-deep .item_tag.active-class{
  border: 1px solid #0052D9;
}
::v-deep .custom-select .el-tag {
  display: inline-block;
  //max-width: 130px; /* 根据需要调整宽度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .el-select.custom-select{
  width: 100%;
}
::v-deep .custom-select .el-tag + .el-tag {
  margin-left: 6px; /* 调整标签之间的间距 */
}
::v-deep .custom-select .el-tag:nth-child(n+3) {
  display: none; /* 隐藏第三个及以后的标签 */
}
::v-deep .custom-select .el-tag:nth-child(2) {
  margin-right: 4px; /* 在第二个标签后留出一些空间 */
}
//::v-deep  .custom-select .el-tag:nth-child(2)::after {
//  content: "+";
//  margin-left: 4px;
//}
::v-deep .el-cascader.el-cascader .el-input .el-input__inner{
  width: 100%;
}
.result_area{
  margin-top: 20px;
  border-radius: 5px;
  padding: 14px 12px;
  background-color: rgba(255,255,255,1);
  border: 1px solid rgba(239,239,239,1);
  .tag_list{
    max-height: 300px;
    overflow: auto;
  }
}
</style>